/**
 * Validation utilities for vehicle forms
 */
import { useToast } from "@/hooks/use-toast";

// Type for vehicle form data
export interface VehicleFormData {
  vehicleType: string;
  vehicleYear: string;
  vehicleColor: string;
  vehicleCapacity: string;
  licensePlate: string;
  vehicleMake: string;
  licensePlateRegion: string;
  selectedAmenities: string[];
  attestation: boolean;
}

// Form validation function
export const validateVehicleForm = (formData: VehicleFormData, toast: ReturnType<typeof useToast>["toast"]) => {
  if (!formData.attestation) {
    toast({
      title: "Attestation required",
      description: "Please confirm your vehicles are properly inspected and insured",
      variant: "destructive",
    });
    return false;
  }
  
  if (!formData.vehicleType || 
      !formData.vehicleYear || 
      !formData.vehicleColor || 
      !formData.licensePlate || 
      !formData.vehicleMake || 
      !formData.vehicleCapacity || 
      !formData.licensePlateRegion) {
    toast({
      title: "Missing information",
      description: "Please fill in all required fields",
      variant: "destructive",
    });
    return false;
  }
  
  return true;
};

// Convert form data to API payload
export const createVehiclePayload = (formData: VehicleFormData) => {
  // Convert amenity string IDs to numbers for the API
  const amenitiesIds = formData.selectedAmenities.map(id => {
    // If the ID is already numeric, use it as is
    // Otherwise, it might be one of our fallback string IDs from constants
    const numId = parseInt(id);
    return isNaN(numId) ? id : numId;
  });
  
  return {
    make: formData.vehicleMake,
    type: formData.vehicleType,
    year: parseInt(formData.vehicleYear),
    color: formData.vehicleColor,
    capacity: parseInt(formData.vehicleCapacity),
    license_plate: formData.licensePlate,
    license_plate_region_id: parseInt(formData.licensePlateRegion),
    amenities: amenitiesIds,
    paperwork_ok: formData.attestation
  };
};
